(function(){
  var fmt=function(n){return '$'+Math.round(n).toLocaleString('es-CL')};
  function el(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt!=null)e.textContent=txt;return e}
  /* Reseñas que se ocultan en la tienda (siguen existiendo en Judge.me): autor + título exactos. No cuentan en el promedio ni en el total. */
  var HIDE_REVIEWS=[
    {name:'Alexander Gotz',title:'Exquisita pero no es granola'},
    {name:'Francisca',title:'Me gustó este pack porque es muy variado!'}
  ];
  function loadReviews(root){
    var sec=root.querySelector('[data-revsec]'); if(!sec||sec.dataset.done)return; sec.dataset.done='1';
    var box=sec.querySelector('[data-rev]'); var big=sec.querySelector('[data-revbig]');
    var ids=(sec.dataset.ids||'').split(',').filter(Boolean);
    /* Packs: se suman las reseñas de todos los productos que incluye (y de los demás formatos de cada uno): cada panel de "Lo que llevas en cada pack" trae sus IDs en data-rids y el nombre del producto en data-rname, que se muestra en cada reseña */
    var names={},isPack=false;
    root.querySelectorAll('.pks-s[data-rids]').forEach(function(s){isPack=true;s.dataset.rids.split(',').forEach(function(i){i=i.trim();if(i){ids.push(i);if(!names[i]&&s.dataset.rname)names[i]=s.dataset.rname}})});
    ids=ids.filter(function(v,k,a){return a.indexOf(v)===k});
    var shop=(window.Shopify&&Shopify.shop)||sec.dataset.shop;
    if(!ids.length||!shop){sec.hidden=true;return}
    Promise.all(ids.map(function(id){
      return fetch('https://judge.me/reviews/reviews_for_widget?url='+shop+'&shop_domain='+shop+'&platform=shopify&page=1&per_page=50&product_id='+id)
        .then(function(r){return r.json()}).catch(function(){return null});
    })).then(function(rs){
      var all=[],total=0,sum=0,n=0,hid=0;
      rs.forEach(function(j,ix){
        if(!j||!j.html)return; total+=(j.total_count||0);
        var src=names[ids[ix]]||'';
        var d=new DOMParser().parseFromString(j.html,'text/html');
        d.querySelectorAll('.jdgm-rev').forEach(function(e){
          var r=e.querySelector('.jdgm-rev__rating'); var st=r?parseInt(r.getAttribute('data-score'),10)||0:0;
          var body=((e.querySelector('.jdgm-rev__body')||{}).textContent||'').trim();
          var title=((e.querySelector('.jdgm-rev__title')||{}).textContent||'').trim();
          var name=((e.querySelector('.jdgm-rev__author')||{}).textContent||'').trim();
          if(HIDE_REVIEWS.some(function(h){return h.name===name&&h.title===title})){hid++;return}
          if(st){sum+=st;n++}
          if(st>=4&&body.length>=12)all.push({st:st,body:body,title:title,name:name,src:src,ok:!!e.querySelector('.jdgm-rev__buyer-badge')});
        });
      });
      total=Math.max(0,total-hid);
      if(!all.length){sec.hidden=true;return}
      all.sort(function(a,b){return b.body.length-a.body.length});
      var avg=(n?(sum/n).toFixed(1):'5.0'),cnt=(total||n);
      big.textContent='';
      big.appendChild(el('span','st','★★★★★')).setAttribute('aria-hidden','true');
      big.appendChild(document.createTextNode(avg+' / 5 · '+cnt+' reseñas'));
      /* Packs: el promedio y el total junto al título son los de todas las reseñas juntas (no solo las del propio pack) */
      if(isPack){
        var h1=root.querySelector('.top h1'),rt=root.querySelector('.top .rate');
        if(!rt&&h1){var mr=root.querySelector('.top .metarow');if(!mr){mr=el('div','metarow');h1.parentNode.insertBefore(mr,h1)}rt=el('p','rate');mr.insertBefore(rt,mr.firstChild)}
        if(rt){rt.textContent='';rt.appendChild(el('span','st','★★★★★')).setAttribute('aria-hidden','true');rt.appendChild(document.createTextNode(avg+'('+cnt+')'))}
      }
      all.slice(0,6).forEach(function(r){
        var c=el('div','rcard');
        c.appendChild(el('div','st',new Array(r.st+1).join('★')));
        if(r.src)c.appendChild(el('div','pf','Reseña de '+r.src));
        if(r.title)c.appendChild(el('p','rt',r.title));
        c.appendChild(el('p',null,r.body));
        c.appendChild(el('div','nm',r.name||'Cliente'));
        if(r.ok)c.appendChild(el('div','vf','Compra verificada'));
        box.appendChild(c);
      });
      sec.hidden=false;
      if(all.length>3&&!sec.querySelector('.rnav')){
        var nav=el('div','rnav'),pv=el('button'),nx=el('button');
        pv.type=nx.type='button';
        pv.setAttribute('aria-label','Reseñas anteriores');nx.setAttribute('aria-label','Reseñas siguientes');
        var ic='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="';
        pv.innerHTML=ic+'M15 5l-7 7 7 7"/></svg>';nx.innerHTML=ic+'M9 5l7 7-7 7"/></svg>';
        var step=function(d){var c=box.querySelector('.rcard');if(c)box.scrollBy({left:d*(c.getBoundingClientRect().width+16),behavior:'smooth'})};
        var upd=function(){pv.disabled=box.scrollLeft<=2;nx.disabled=box.scrollLeft+box.clientWidth>=box.scrollWidth-2};
        pv.addEventListener('click',function(){step(-1)});nx.addEventListener('click',function(){step(1)});
        box.addEventListener('scroll',upd,{passive:true});
        nav.appendChild(pv);nav.appendChild(nx);sec.appendChild(nav);upd();
      }
    });
  }
  function trackDots(sec,tr){
    if(!sec||!tr)return;
    var cards=[].slice.call(tr.children).filter(function(c){return c.nodeType===1});
    if(cards.length<2||sec.querySelector('.rdots'))return;
    var dots=el('div','rdots');
    var left=function(c){return c.getBoundingClientRect().left-tr.getBoundingClientRect().left+tr.scrollLeft};
    cards.forEach(function(c,i){
      var d=el('button');d.type='button';d.setAttribute('aria-label','Ir al elemento '+(i+1));
      d.addEventListener('click',function(){tr.scrollTo({left:left(c),behavior:'smooth'})});
      dots.appendChild(d);
    });
    tr.insertAdjacentElement('afterend',dots);
    var ds=[].slice.call(dots.children);
    var upd=function(){
      var over=tr.scrollWidth>tr.clientWidth+2;
      dots.hidden=!over;
      if(!over)return;
      var best=0,bd=1e9;
      cards.forEach(function(c,i){var d=Math.abs(left(c)-tr.scrollLeft);if(d<bd){bd=d;best=i}});
      if(tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-2)best=cards.length-1;
      ds.forEach(function(d,i){d.className=i===best?'on':''});
    };
    tr.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd);
    upd();
  }
  function recDots(root){var s=root.querySelector('.recs');trackDots(s,s&&s.querySelector('.track'))}
  function xsDots(root){var s=root.querySelector('.bjxs');trackDots(s,s&&s.querySelector('.track'))}
  function refreshDrawer(){
    var cur=document.querySelector('#shopify-section-cart-drawer-section');
    if(!cur)return Promise.resolve();
    return fetch('/?sections=cart-drawer-section',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(j){
      var d=new DOMParser().parseFromString(j['cart-drawer-section']||'','text/html');
      var n=d.querySelector('#shopify-section-cart-drawer-section');
      if(n)cur.innerHTML=n.innerHTML;
    }).catch(function(){});
  }
  function addToCart(btn,root){
    if(btn.disabled)return;
    var label=btn.textContent;
    btn.disabled=true;btn.textContent='Agregando…';
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:parseInt(btn.dataset.id,10),quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
      .then(function(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()})})
      .then(function(c){
        var ci=document.querySelector('cart-icon');
        if(ci&&typeof ci.renderCartBubble==='function')ci.renderCartBubble(c.item_count);
        if(root._refreshCart)root._refreshCart();
        return refreshDrawer();
      })
      .then(function(){
        btn.textContent='Agregado ✓';btn.classList.add('ok');
        var dr=document.querySelector('#cart-drawer');
        if(dr&&typeof dr.open==='function')dr.open();
        setTimeout(function(){btn.disabled=false;btn.classList.remove('ok');btn.textContent=label},2400);
      })
      .catch(function(){btn.textContent='No se pudo agregar';setTimeout(function(){btn.disabled=false;btn.textContent=label},2400)});
  }
  function shipHtml(free,freeReg,total,cartBase){
    var two=freeReg>free, max=two?freeReg:free;
    var pct=Math.min(100,total/max*100);
    var okRm=total>=free, okReg=two&&total>=freeReg, s;
    if(two){
      if(okReg)s='Tienes envío gratis a todo Chile.';
      else if(okRm)s='Tienes envío gratis en la RM. Para regiones te faltan '+fmt(freeReg-total)+'.';
      else s='Te faltan '+fmt(free-total)+' para el envío gratis en la RM.';
    }else{
      s=okRm?'Tienes envío gratis.':'Te faltan '+fmt(free-total)+' para el envío gratis.';
    }
    if(cartBase>0)s+=' <span style="font-weight:400;color:#6b6b6e">Incluye tu carrito.</span>';
    var m='';
    if(two){
      m+='<span class="ms'+(okRm?' ok':'')+'" style="left:'+(free/max*100)+'%"><em>RM · '+fmt(free)+'</em></span>';
      m+='<span class="ms last'+(okReg?' ok':'')+'" style="left:100%"><em>Regiones · '+fmt(freeReg)+'</em></span>';
    }else{
      m+='<span class="ms last'+(okRm?' ok':'')+'" style="left:100%"><em>Envío gratis · '+fmt(free)+'</em></span>';
    }
    return '<p class="sl">'+s+'</p><div class="bar"><i style="width:'+pct+'%"></i>'+m+'</div>';
  }
  function fitGal(root){
    var g=root.querySelector('.gal'),t=g&&g.querySelector('[data-thumbs]');
    if(!g||!t)return;
    var up=g.querySelector('[data-tup]'),dn=g.querySelector('[data-tdn]');
    if(!root.classList.contains('lay-perfect')||window.innerWidth<=880){
      ['--tg','--th','--ts'].forEach(function(p){g.style.removeProperty(p)});
      if(up)up.hidden=true;if(dn)dn.hidden=true;return;
    }
    var w=g.clientWidth;if(!w)return;
    var ts=Math.floor(Math.min(84,(w-46)/6));
    var h=w-ts-14;
    var gap=Math.max(8,Math.min(16,Math.floor((h-5*ts)/4)));
    var th=Math.min(h,5*ts+4*gap);
    g.style.setProperty('--ts',ts+'px');g.style.setProperty('--tg',gap+'px');g.style.setProperty('--th',th+'px');
    if(!up||!dn)return;
    var upd=function(){
      var more=t.scrollHeight>t.clientHeight+2;
      up.hidden=!more||t.scrollTop<=2;
      dn.hidden=!more||t.scrollTop+t.clientHeight>=t.scrollHeight-2;
    };
    if(!t._bound){
      t._bound=1;
      t.addEventListener('scroll',upd,{passive:true});
      up.addEventListener('click',function(){t.scrollBy({top:-(ts+gap)*3,behavior:'smooth'})});
      dn.addEventListener('click',function(){t.scrollBy({top:(ts+gap)*3,behavior:'smooth'})});
    }
    upd();
  }
  function mgal(root){
    var stg=root.querySelector('.stage'),th=[].slice.call(root.querySelectorAll('[data-thumbs] button'));
    if(!stg||th.length<2||stg.querySelector('.mg-dots'))return;
    var ico='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="';
    var pv=el('button','mg-a prev'),nx=el('button','mg-a next'),dots=el('div','mg-dots'),pre=false;
    pv.type=nx.type='button';
    pv.setAttribute('aria-label','Foto anterior');nx.setAttribute('aria-label','Foto siguiente');
    pv.innerHTML=ico+'M15 5l-7 7 7 7"/></svg>';nx.innerHTML=ico+'M9 5l7 7-7 7"/></svg>';
    dots.setAttribute('aria-hidden','true');
    var ds=th.map(function(){var d=document.createElement('i');dots.appendChild(d);return d});
    function cur(){for(var i=0;i<th.length;i++)if(th[i].getAttribute('aria-current')==='true')return i;return 0}
    function sync(){var c=cur();ds.forEach(function(d,i){d.className=i===c?'on':''})}
    function preload(){if(pre)return;pre=true;th.forEach(function(b){var i=new Image();i.src=b.dataset.src})}
    function go(i){preload();th[(i+th.length)%th.length].click()}
    pv.addEventListener('click',function(){go(cur()-1)});
    nx.addEventListener('click',function(){go(cur()+1)});
    th.forEach(function(b){b.addEventListener('click',sync)});
    var x0=0,y0=0;
    stg.addEventListener('touchstart',function(e){preload();x0=e.touches[0].clientX;y0=e.touches[0].clientY},{passive:true});
    stg.addEventListener('touchend',function(e){var t=e.changedTouches[0],dx=t.clientX-x0,dy=t.clientY-y0;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3)go(cur()+(dx<0?1:-1))},{passive:true});
    stg.appendChild(pv);stg.appendChild(nx);stg.appendChild(dots);sync();
  }
  function init(root,qty){
    var price=parseInt(root.dataset.price,10)||0, free=parseInt(root.dataset.free,10)||0, freeReg=parseInt(root.dataset.freeReg,10)||0;
    var title=root.dataset.title||'';
    var q=function(s){return root.querySelector(s)};
    var cartBase=0;
    qty=qty||1;
    function draw(){
      var sel=price*qty, total=cartBase+sel;
      q('[data-qty]').textContent=qty; q('[data-qty-input]').value=qty;
      if(free>0)q('[data-ship]').innerHTML=shipHtml(free,freeReg,total,cartBase);
      q('[data-stitle]').textContent=title+' · '+fmt(sel);
    }
    function refreshCart(){
      return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){
        cartBase=Math.round((c.items_subtotal_price||0)/100); draw();
      }).catch(function(){});
    }
    root._refreshCart=refreshCart;
    refreshCart();
    q('[data-plus]').addEventListener('click',function(){qty=Math.min(10,qty+1);draw()});
    q('[data-minus]').addEventListener('click',function(){qty=Math.max(1,qty-1);draw()});
    var bd=q('.badges [data-badge]');
    function setBadge(t){if(!bd)return; bd.textContent=t||''; bd.parentNode.style.display=t?'':'none'}
    root.querySelectorAll('[data-thumbs] button').forEach(function(b){
      b.addEventListener('click',function(){
        var m=q('[data-main]'); if(m)m.src=b.dataset.src;
        setBadge(b.dataset.badge);
        root.querySelectorAll('[data-thumbs] button').forEach(function(x){x.setAttribute('aria-current',x===b?'true':'false')});
      });
    });
    mgal(root);
    recDots(root);
    xsDots(root);
    var st=q('[data-sticky]'), add=q('[data-add]');
    q('[data-sadd]').addEventListener('click',function(){add.click()});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(e){st.classList.toggle('show',!e[0].isIntersecting && e[0].boundingClientRect.top<0)}).observe(add);
    }
    root._qty=function(){return qty};
    draw();
    fitGal(root);
    requestAnimationFrame(function(){fitGal(root)});
    loadReviews(root);
  }
  function swap(root,href,push){
    var url=new URL(href,location.href);
    var target=url.pathname+location.search;
    root.classList.add('is-loading');
    fetch(target,{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var n=doc.querySelector('[data-bjpdp]');
      if(!n){location.href=target;return}
      var keep=root._qty?root._qty():1;
      var h=root.offsetHeight; root.style.minHeight=h+'px';
      root.innerHTML=n.innerHTML;
      ['price','free','freeReg','title'].forEach(function(k){root.dataset[k]=n.dataset[k]});
      document.title=doc.title;
      if(push)history.pushState({bj:1},'',target);
      init(root,keep);
      root.classList.remove('is-loading');
      setTimeout(function(){root.style.minHeight=''},50);
    }).catch(function(){location.href=target});
  }
  document.querySelectorAll('[data-bjpdp]').forEach(function(root){
    if(root.dataset.ready)return; root.dataset.ready='1';
    init(root,1);
    root.addEventListener('click',function(e){
      var x=e.target.closest('[data-xadd]');
      if(x){e.preventDefault();addToCart(x,root);return}
      var a=e.target.closest('.it');
      if(!a||a.getAttribute('aria-current')==='true')return;
      if(e.metaKey||e.ctrlKey||e.shiftKey||e.button!==0)return;
      e.preventDefault(); swap(root,a.href,true);
    });
    window.addEventListener('popstate',function(){swap(root,location.href,false)});
    window.addEventListener('resize',function(){fitGal(root)});
    window.addEventListener('load',function(){fitGal(root)});
  });
})();